import Thumb from './Thumb';

export default Thumb;
